import { createContext, useCallback, useState } from "react";
import { CheckCircle2, AlertTriangle, XCircle, Info } from "lucide-react";
import { T } from "../constants/theme";

export const ToastContext = createContext(null);

const VARIANTS = {
  success: { accent: "#2d9e6a", Icon: CheckCircle2 },
  error: { accent: "#e0574f", Icon: XCircle },
  warning: { accent: "#C49A3C", Icon: AlertTriangle },
  info: { accent: "#3fa9c9", Icon: Info },
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const addToast = useCallback((msg, type = "success") => {
    const id = `${Date.now()}-${Math.random()}`;
    setToasts((t) => [...t, { id, msg, type }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3500);
  }, []);
  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <div
        style={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          gap: 12,
          maxWidth: 360,
          width: "calc(100% - 48px)",
        }}
      >
        {toasts.map((t) => {
          const v = VARIANTS[t.type] || VARIANTS.success;
          const Icon = v.Icon;
          return (
            <div
              key={t.id}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 12,
                background: T.surface,
                color: T.ink,
                padding: "14px 18px",
                borderRadius: 14,
                boxShadow: "0 16px 40px rgba(0,0,0,0.06)",
                borderLeft: `3px solid ${v.accent}`,
                animation: "slideUp .35s cubic-bezier(.4,0,.2,1)",
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              <Icon size={20} color={v.accent} style={{ flexShrink: 0, marginTop: 1 }} />
              <span style={{ fontSize: 14, fontWeight: 500, lineHeight: 1.5 }}>{t.msg}</span>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}
